import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';
import Button from 'rebook/apps/base/components/Button';
import { URLS } from 'rebook/apps/base/constants';

import styles from './style.scss';


const RegistrationOffer = ({ freeBooksCounter }) => (
  <div className={classNames(styles.freeSubscriptionContainer, 'jest-registration-offer')}>
    <div className={styles.subscriptionFreeIcon} />
    <div className={styles.offerInfo}>
      <div className="title-2">Чтобы продолжить, зарегистрируйтесь в MyBook</div>
      <p>Вы сможете бесплатно читать более {numberWithSpace(freeBooksCounter)} книг</p>
      <Button link={URLS.authForm} extraClassName={styles.trialButton}>Зарегистрироваться</Button>
    </div>
  </div>
);

const ThreeMonthsOffer = ({ totalBooksCounter, audioBooksCounter }) => (
  <div className={classNames(styles.threeMonthOfferContainer, 'jest-three-month-offer')}>
    <div className={styles.headPhonesWithTabletImage} />
    <div className={styles.tabletImage} />
    <div className={styles.threeMonthOfferTitle}>
      <div className={styles.threeMonthOfferHeader}>
        Оформите <br className={styles.offerHeaderWordWrap} />
        подписку, чтобы <br className={styles.offerHeaderWordWrap} />
        продолжить читать <br className={styles.offerHeaderWordWrap} />
        эту книгу
      </div>
      <span className={styles.threeMonthOfferText}>
        <b>
          {numberWithSpace(totalBooksCounter)}
        </b>
          &nbsp;книг&nbsp;<br className={styles.offerHeaderWordWrap} />
          и&nbsp;
        <b>
          {numberWithSpace(audioBooksCounter)}
        </b>
          &nbsp;аудиокниг
      </span>
      <Button
        url="/trial/?from=bookpage_fragment"
        extraClassName={styles.threeMonthOfferButton}
        theme="advert">
        Получить 14 дней бесплатно
      </Button>
    </div>
    <div className={styles.headPhonesImage} />
  </div>
);

const BookFragmentViewTrial = ({ book, booksPerSubscriptionCounter }) => {
  const { total, audio, free } = booksPerSubscriptionCounter;
  return (
    <React.Fragment>
      {book.subscription_id === null
        ? (
          <RegistrationOffer freeBooksCounter={free} />
        )
        : (
          <ThreeMonthsOffer
            totalBooksCounter={total}
            audioBooksCounter={audio} />
        )}
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

export default connect(mapStateToProps, null)(BookFragmentViewTrial);
